import { useState } from 'react';
import { Music as MusicIcon, Play, Heart, Download, History, ExternalLink, Headphones, Volume2, Radio, Disc, ListMusic } from 'lucide-react';

export default function Music() {
  const [showIframe, setShowIframe] = useState(false);

  const musicFeatures = [
    { icon: <Play className="w-5 h-5" />, label: '在线播放', desc: '海量音乐随时听' },
    { icon: <Heart className="w-5 h-5" />, label: '我的喜欢', desc: '收藏喜爱的歌曲' },
    { icon: <Download className="w-5 h-5" />, label: '下载记录', desc: '离线也能听' },
    { icon: <History className="w-5 h-5" />, label: '最近播放', desc: '快速找回' },
  ];

  const categories = [
    { name: '推荐', icon: <Disc className="w-4 h-4" /> },
    { name: '歌单', icon: <ListMusic className="w-4 h-4" /> },
    { name: '精选', icon: <Radio className="w-4 h-4" /> },
    { name: 'MV', icon: <Play className="w-4 h-4" /> },
    { name: '歌手', icon: <MusicIcon className="w-4 h-4" /> },
  ];

  return (
    <div className="animate-fade-in pb-20">
      {/* 标题栏 */}
      <div className="sticky top-0 z-40 bg-telegram-dark/95 backdrop-blur-md border-b border-telegram-secondary/10 px-4 py-3">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold text-telegram-text flex items-center">
            <MusicIcon className="w-6 h-6 mr-2 text-pink-400" />
            魔力音乐
          </h1>
          <button
            onClick={() => setShowIframe(!showIframe)}
            className="p-2 rounded-lg hover:bg-pink-500/20 transition-colors"
          >
            {showIframe ? (
              <span className="text-xs text-pink-400">关闭嵌入</span>
            ) : (
              <ExternalLink className="w-5 h-5 text-pink-400" />
            )}
          </button>
        </div>
      </div>

      <div className="px-4 pt-4">
        {/* 音乐服务介绍 */}
        <div className="bg-gradient-to-br from-pink-500/10 to-purple-500/10 rounded-xl border border-pink-500/30 p-4 mb-6">
          <div className="flex items-start space-x-3 mb-4">
            <div className="p-3 bg-gradient-to-br from-pink-500/20 to-purple-500/20 rounded-xl">
              <Headphones className="w-10 h-10 text-pink-400" />
            </div>
            <div className="flex-1">
              <h2 className="font-bold text-telegram-text text-lg mb-1">海量音乐资源</h2>
              <p className="text-sm text-telegram-secondary">
                在线音乐、精选歌单、MV视频、歌手专区，随时随地畅听高品质音乐
              </p>
            </div>
          </div>

          {/* 功能特点 */}
          <div className="grid grid-cols-2 gap-3 mb-4">
            {musicFeatures.map((feature, index) => (
              <div key={index} className="flex items-center space-x-3 p-3 bg-telegram-dark rounded-lg">
                <div className="text-pink-400">{feature.icon}</div>
                <div>
                  <p className="text-sm font-medium text-telegram-text">{feature.label}</p>
                  <p className="text-xs text-telegram-secondary">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* 音质选择 */}
          <div className="flex items-center space-x-3 p-3 bg-telegram-dark rounded-lg mb-4">
            <Volume2 className="w-6 h-6 text-pink-400" />
            <div className="flex-1">
              <p className="text-sm font-medium text-telegram-text">多种音质选择</p>
              <div className="flex space-x-2 mt-1">
                <span className="text-xs px-2 py-0.5 bg-gray-500/20 text-gray-400 rounded">标准</span>
                <span className="text-xs px-2 py-0.5 bg-blue-500/20 text-blue-400 rounded">高品</span>
                <span className="text-xs px-2 py-0.5 bg-purple-500/20 text-purple-400 rounded">无损</span>
              </div>
            </div>
          </div>

          {/* 分类标签 */}
          <div className="flex flex-wrap gap-2 mb-4">
            {categories.map((cat, index) => (
              <span
                key={index}
                className="flex items-center space-x-1 px-3 py-1.5 bg-telegram-dark rounded-full text-xs text-telegram-secondary"
              >
                {cat.icon}
                <span>{cat.name}</span>
              </span>
            ))}
          </div>

          {/* 打开音乐播放器按钮 */}
          <a
            href="http://129.154.52.248:8099/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center space-x-2 w-full py-3 bg-gradient-to-r from-pink-500 to-purple-500 rounded-xl text-white font-medium hover:from-pink-600 hover:to-purple-600 transition-all"
          >
            <Radio className="w-5 h-5" />
            <span>打开魔力音乐</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        {/* 嵌入播放器 */}
        {showIframe && (
          <div className="bg-telegram-dark rounded-xl border border-pink-500/30 overflow-hidden mb-6">
            <div className="flex items-center justify-between px-4 py-2 border-b border-pink-500/20">
              <span className="text-sm font-medium text-telegram-text">魔力音乐播放器</span>
              <button
                onClick={() => setShowIframe(false)}
                className="text-xs text-telegram-secondary hover:text-pink-400"
              >
                关闭
              </button>
            </div>
            <div className="relative w-full h-96">
              <iframe
                src="http://129.154.52.248:8099/"
                title="魔力音乐"
                className="w-full h-full border-0"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </div>
          </div>
        )}

        {/* 提示信息 */}
        <div className="p-4 bg-telegram-dark rounded-xl">
          <p className="text-xs text-telegram-secondary text-center">
            💡 提示：点击上方按钮在新窗口打开音乐播放器，享受完整的音乐体验
          </p>
        </div>
      </div>
    </div>
  );
}
